import { mapRestaurant } from '@/entities/restaurant/model/mapRestaurant'
import { publicGet, publicList } from '@/entities/public/api/publicRequest'

const LIST_PATH = '/public/restaurants'

export async function fetchRestaurantsPage({
  limit = 20,
  skip = 0,
  filter = {},
  sort = {},
  restaurantOrderSeed = '',
} = {}) {
  const payload = await publicList(LIST_PATH, {
    limit,
    skip,
    filter,
    sort,
    restaurantOrderSeed,
  })
  const list = Array.isArray(payload.data) ? payload.data : []
  const total = Number(payload.total)

  return {
    items: list.map((item) => mapRestaurant(item)),
    total: Number.isFinite(total) ? total : list.length,
    restaurantOrderSeed:
      typeof payload.restaurant_order_seed === 'string' ? payload.restaurant_order_seed.trim() : '',
  }
}

export async function fetchRestaurants({
  limit = 100,
  skip = 0,
  filter = {},
  sort = {},
  restaurantOrderSeed = '',
} = {}) {
  const { items } = await fetchRestaurantsPage({
    limit,
    skip,
    filter,
    sort,
    restaurantOrderSeed,
  })
  return items
}

export async function fetchRestaurantById(id) {
  if (!id) {
    return null
  }

  try {
    const payload = await publicGet(`/public/restaurant/${id}`)
    return mapRestaurant(payload.data)
  } catch (error) {
    if (error.code === 'resto_not_found' || error.code === 'resto_get_error') {
      return null
    }
    throw error
  }
}
